import * as React from "react";
import Paper from "@mui/material/Paper";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import moment from "moment";
import { Grid, IconButton, Toolbar } from "@mui/material";
import DonutChart from "../Charts/DonutChart";
import { useSelector } from "react-redux";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import CountUp from "react-countup";
import "./style.css";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import { Helmet } from "react-helmet-async";
import LineChartHome from "../Charts/LineChart";
import { StackedBarChartPerInstitution } from "../Charts/BarChart Per Institution";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const columns = [
  {
    field: "code",
    headerName: "Code",
    minWidth: 170,
    align: "left",
  },
  {
    field: "institution",
    headerName: "Institution",
    minWidth: 170,
    align: "left",
  },
  {
    field: "tenure",
    headerName: "Tenure",
    minWidth: 170,
    align: "left",
  },
  {
    field: "purchase_date",
    headerName: "Purchase Date",
    minWidth: 170,
    align: "left",
  },
  {
    field: "maturity_date",
    headerName: "Maturity Date",
    minWidth: 170,
    align: "left",
  },
  {
    field: "rate_type",
    headerName: "Rate Type",
    minWidth: 170,
    align: "left",
  },
  {
    field: "cost",
    headerName: "Cost",
    minWidth: 170,
    align: "left",
    valueFormatter: ({ value }) => value.toLocaleString(),
  },
  {
    field: "total_interest",
    headerName: "Total Interest",
    minWidth: 170,
    valueFormatter: ({ value }) => value.toLocaleString(),
  },
  {
    field: "fair_value",
    headerName: "Fair Value",
    minWidth: 170,
  },
];
function showMonthData(
  id,
  code,
  institution,
  tenure,
  purchase_date,
  maturity_date,
  rate_type,
  cost,
  total_interest
) {
  const fair_value =
    rate_type === "discount rate"
      ? cost.toLocaleString()
      : (cost + total_interest).toLocaleString();
  return {
    id,
    code,
    institution,
    tenure,
    purchase_date,
    maturity_date,
    rate_type,
    cost,
    total_interest,
    fair_value,
  };
}
export default function Analytics() {
  function CustomToolbar() {
    return (
      <GridToolbarContainer
        style={{ backgroundColor: "#f8f8f8", color: "#000" }}
      >
        <GridToolbarExport style={{ color: "#000" }} />
      </GridToolbarContainer>
    );
  }
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [filterData] = React.useState({
    interest_charged_start: "",
    interest_charged_end: "",
  });
  const totalCost = [];
  const totalinterest_charged = [];
  const totalInterestUnEarned = [];
  const accumInterest = [];
  const fairValue = [];

  function createData(
    id,
    code,
    certificate_number,
    institution,
    investment_type,
    regulator,
    rate,
    purchase_date,
    maturity_date,
    tenure,
    cost,
    impairment,
    total_interest,
    daily_interest,
    rate_type
  ) {
    //  we are check whether an asset is exhausted or not

    let status = moment(maturity_date) > moment() ? "Active" : "Matured";
    // ----------------------------------------------------------------
    const date2 = moment();
    const date1 = moment(purchase_date);
    let days_earned = date2.diff(date1, "days") + 1;
    let interest_charged = days_earned * daily_interest;
    let days_unearned = tenure - days_earned;
    let cumulative_interest = days_earned * daily_interest;
    let interest_unearned = days_unearned * daily_interest;
    let fair_value =
      rate_type === "interest rate"
        ? cost + cumulative_interest - impairment
        : cost - impairment;
    // ! WE DON'T CHARGE DEPN ON LAND

    // ! Revalued Started here -----------------------//!

    //! ------------Revalued ended here-------------------------///!

    // !------------start------------------------------------
    // checking if the asset has been exhausted;
    // if (cost - cumulative_interest < 1) {
    //   interest_unearned = 0;
    // }
    if (status === "Matured") {
      days_earned = moment(maturity_date).diff(purchase_date, "days");
      days_unearned = 0;

      cumulative_interest = days_earned * daily_interest;
      interest_unearned = days_unearned * daily_interest;
      interest_charged = 0;
      fair_value =
        rate_type === "interest rate"
          ? cost + cumulative_interest - impairment
          : cost - impairment;
    }
    // !------------- Exhausted Checking End---------------------------

    // ! things to do when the interest_charged start date and end date are all selected--------------//Start

    if (filterData.interest_charged_start && filterData.interest_charged_end) {
      if (
        filterData.interest_charged_start &&
        filterData.interest_charged_end &&
        moment(purchase_date) < moment(filterData.interest_charged_start) &&
        moment(maturity_date) < moment(filterData.interest_charged_start) &&
        status === "Matured"
      ) {
        cumulative_interest = cost;
        interest_unearned = 0;
        fair_value =
          rate_type === "interest rate"
            ? cost + cumulative_interest - impairment
            : cost - impairment;
      }

      if (moment(filterData.interest_charged_end) < moment(purchase_date)) {
        cost = 0;
        fair_value = 0;
        interest_unearned = 0;
        cumulative_interest = 0;
        days_earned = 0;
        days_unearned = 0;
        interest_charged = 0;

        status = "investment was not available then";
      }

      // check if the interest_charged end date is within the exhausted date //! Start------------

      if (
        moment(purchase_date) <= moment(filterData.interest_charged_start) &&
        moment(maturity_date) > moment(filterData.interest_charged_end)
      ) {
        const diff = moment(filterData.interest_charged_end).diff(
          moment(filterData.interest_charged_start),
          "days"
        );
        const cummDateDiff = moment(filterData.interest_charged_end).diff(
          moment(purchase_date),
          "days"
        );
        days_earned = cummDateDiff + 1;
        days_unearned = tenure - (cummDateDiff + 1);
        interest_unearned = (tenure - (cummDateDiff + 1)) * daily_interest;
        cumulative_interest = (cummDateDiff + 1) * daily_interest;
        fair_value =
          rate_type === "interest rate"
            ? cost + cumulative_interest - impairment
            : cost - impairment;
        interest_charged = (diff + 1) * daily_interest;
      }
      // ----------!End!----------------//!

      // we will check if the purchase date is less than the start date and the exhaustion date  is greater than the start date and also the exhaustion date is less than the end date//! start

      if (
        moment(purchase_date) < moment(filterData.interest_charged_start) &&
        moment(maturity_date) >= moment(filterData.interest_charged_start) &&
        moment(maturity_date) <= moment(filterData.interest_charged_end)
      ) {
        const diff = moment(maturity_date).diff(
          moment(filterData.interest_charged_start),
          "days"
        );
        const cummDateDiff = moment(maturity_date).diff(
          moment(purchase_date),
          "days"
        );
        //! this is where I did the negative changes
        days_earned = cummDateDiff;
        days_unearned = tenure - cummDateDiff;
        interest_unearned = (tenure - cummDateDiff) * daily_interest;
        cumulative_interest = cummDateDiff * daily_interest;
        fair_value =
          rate_type === "interest rate"
            ? cost + cumulative_interest - impairment
            : cost - impairment;
        interest_charged = diff * daily_interest;
        // ! the change was done here
        // ! I am looking for a scenario where the purchase date is less than the start and the maturity is less than the end
      }

      // ----------------------//!End---------------------
      if (moment(maturity_date) < moment(filterData.interest_charged_start)) {
        interest_unearned = 0;
        cumulative_interest = days_earned * daily_interest;
        fair_value =
          rate_type === "interest rate"
            ? cost + cumulative_interest - impairment
            : cost - impairment;
      }
      // if (
      //   moment(purchase_date) < moment(filterData.interest_charged_start) &&
      //   moment(maturity_date) <= moment(filterData.interest_charged_end)
      // ) {
      //   days_earned = tenure;
      // }
      // we will check if the purchase date is greater than the start date and the exhaustion date is greater than the end date//!start
      if (
        moment(purchase_date) > moment(filterData.interest_charged_start) &&
        moment(purchase_date) <= moment(filterData.interest_charged_end) &&
        moment(maturity_date) > moment(filterData.interest_charged_end)
        // ! another change too was done here, equal sign was added to the second check
      ) {
        const diff = moment(filterData.interest_charged_end).diff(
          moment(purchase_date),
          "days"
        );
        const cummDateDiff = moment(filterData.interest_charged_end).diff(
          moment(purchase_date),
          "days"
        );

        days_earned = cummDateDiff + 1;
        days_unearned = tenure - (cummDateDiff + 1);
        interest_unearned = (tenure - (cummDateDiff + 1)) * daily_interest;
        cumulative_interest = (cummDateDiff + 1) * daily_interest;
        fair_value =
          rate_type === "interest rate"
            ? cost + cumulative_interest - impairment
            : cost - impairment;
        interest_charged = (diff + 1) * daily_interest;
      }
      if (
        moment(purchase_date) >= moment(filterData.interest_charged_start) &&
        moment(maturity_date) <= moment(filterData.interest_charged_end)
      ) {
        //  we will check if the purchase date is greater than the start date and the exhaustion date is less than the end date;
        // if both the purchase and the exhaustion date are in btn the start and end date;
        const cummDateDiff = moment(maturity_date).diff(
          moment(purchase_date),
          "days"
        );

        days_earned = cummDateDiff;
        days_unearned = 0;
        interest_unearned = 0;
        cumulative_interest = tenure * daily_interest;
        fair_value =
          rate_type === "interest rate"
            ? cost + cumulative_interest - impairment
            : cost - impairment;
        const diff = moment(maturity_date).diff(moment(purchase_date), "days");
        interest_charged = diff * daily_interest;
      }
    }
    // -----------------------End of instance-------------------//!End
    // ! we will be catching all disposed assets instances here

    //  we will check if the disposal happened before the start date

    // we will check if the disposal date is greater than the start date and is less than or equal to the end date;

    // ! Depn start and depn end.-----------------------// End

    totalCost.push(cost);
    totalinterest_charged.push(interest_charged);
    totalInterestUnEarned.push(interest_unearned);
    accumInterest.push(cumulative_interest);
    fairValue.push(fair_value);
    return {
      id,
      code,
      certificate_number,
      institution,
      investment_type,
      regulator,
      rate,
      purchase_date,
      maturity_date,
      tenure,
      days_earned,
      days_unearned,
      cost,
      cumulative_interest,
      interest_unearned,
      impairment,
      fair_value,
      total_interest,
      interest_charged,
      daily_interest,
      status,
      rate_type,
    };
  }
  const approvedInvestments = useSelector((state) => state.approvedInvestment);
  const [data, setData] = React.useState(approvedInvestments);
  const [activeInvestments, setActiveInvestments] = React.useState([]);
  React.useEffect(() => {
    const filteredInvestments = data.filter(
      (investment) => moment(investment.maturity_date) > moment()
    );
    setActiveInvestments(filteredInvestments);
  }, [data]);

  const rows = activeInvestments.map((data) =>
    createData(
      data._id,
      data.code,
      data.certificate_number,
      data.institution,
      data.investment_type,
      data.regulator,
      data.rate,
      moment(data.purchase_date).format("YYYY-MM-DD"),
      moment(data.maturity_date).format("YYYY-MM-DD"),
      data.tenure,
      data.cost,
      data.impaired_amount,
      data.total_interest,
      data.daily_interest,
      data.rate_type
    )
  );
  React.useEffect(() => {
    setData(approvedInvestments);
  }, [approvedInvestments]);
  const monthStats = useSelector((state) => state.month_stats);

  // ! FETCH ALL NEEDED INFOR HERE

  const totalInvestmentCost = totalCost.reduce((acc, val) => acc + val, 0);

  const totalInvestmentInterestUnEarned = totalInterestUnEarned.reduce(
    (acc, val) => acc + val,
    0
  );

  const totalInvestmentFairValue = fairValue.reduce((acc, val) => acc + val, 0);
  const totalImpairment = rows.reduce((acc, obj) => acc + obj.impairment, 0);
  const totalInterest = rows.reduce((acc, obj) => acc + obj.total_interest, 0);
  const totalInterestChared = rows.reduce(
    (acc, obj) => acc + obj.interest_charged,
    0
  );
  // const totalInterest = rows.reduce((acc, obj) => acc + obj.total_interest, 0);
  const rows2 = monthStats.map((data) =>
    showMonthData(
      data._id,
      data.code,
      data.institution,
      data.tenure,
      moment(data.purchase_date).format("MM-DD-YYYY"),
      moment(data.maturity_date).format("MM-DD-YYYY"),
      data.rate_type,
      data.cost.toFixed(2) * 1,
      data.total_interest.toFixed(2) * 1
    )
  );
  return (
    <div style={{ width: "100%" }}>
      <Helmet title="Dashboard | Portfolio Manager" />

      <Grid spacing={2} sx={{ flexGrow: 1 }}>
        <Grid item xs={12}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item>
              <Card
                elevation={0}
                sx={{
                  maxWidth: 345,
                  backgroundColor: "#fff",
                  height: 55,
                  alignItems: "center",
                  boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                }}
              >
                <CardContent>
                  <Typography
                    component="div"
                    variant="body2"
                    style={{
                      // marginBottom: "30px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      color: "#3D4F58",
                      fontSize: "11px",
                    }}
                  >
                    ACTIVE INVESTMENTS
                  </Typography>

                  <Typography variant="body2" color="text.secondary">
                    <CountUp start={0} end={rows.length} duration={3} />
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item>
              <Card
                elevation={0}
                sx={{
                  maxWidth: 240,
                  maxHeight: 200,
                  backgroundColor: "#fff",
                  height: 55,
                  alignItems: "center",
                  boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                }}
              >
                <CardContent>
                  <Typography
                    component="div"
                    variant="body2"
                    style={{
                      // marginBottom: "30px",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      color: "#3D4F58",
                      fontSize: "11px",
                      //
                    }}
                  >
                    TOTAL COST
                  </Typography>

                  <Typography variant="body2" color="text.secondary">
                    <CountUp
                      prefix="GHS "
                      start={0}
                      end={totalInvestmentCost}
                      duration={3}
                    />
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item>
              <Card
                elevation={0}
                sx={{
                  maxWidth: 345,
                  // backgroundColor: "grey",
                  alignItems: "center",
                  height: 55,
                  boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                }}
              >
                <CardContent>
                  <Typography
                    component="div"
                    variant="body2"
                    style={{
                      // marginBottom: "30px",
                      display: "flex",

                      flexDirection: "row",
                      alignItems: "center",
                      color: "#3D4F58",
                      fontSize: "11px",
                    }}
                  >
                    INTEREST CHARGED
                  </Typography>

                  <Typography variant="body2" color="text.secondary">
                    <CountUp
                      prefix="GHS "
                      start={0}
                      end={totalInterestChared}
                      duration={3}
                    />
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item>
              <Card
                elevation={0}
                sx={{
                  maxWidth: 345,
                  backgroundColor: "#fff",
                  height: 55,
                  alignItems: "center",
                  boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                }}
              >
                <CardContent>
                  <Typography
                    component="div"
                    variant="body2"
                    style={{
                      // marginBottom: "30px",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      color: "#3D4F58",
                      fontSize: "11px",
                    }}
                  >
                    INTEREST UNEARNED
                  </Typography>

                  <Typography variant="body2" color="text.secondary">
                    <CountUp
                      start={0}
                      prefix="GHS "
                      end={totalInvestmentInterestUnEarned}
                      duration={3}
                    />
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item>
              <Card
                elevation={0}
                sx={{
                  maxWidth: 345,
                  // backgroundColor: "grey",
                  alignItems: "center",
                  height: 55,
                  boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                }}
              >
                <CardContent>
                  <Typography
                    component="div"
                    variant="body2"
                    style={{
                      // marginBottom: "30px",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      color: "#3D4F58",
                      fontSize: "11px",
                    }}
                  >
                    TOTAL INTEREST
                  </Typography>

                  <Typography variant="body2" color="text.secondary">
                    <CountUp
                      prefix="GHS "
                      start={0}
                      end={totalInterest}
                      duration={3}
                    />
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item>
              <Card
                elevation={0}
                sx={{
                  maxWidth: 345,
                  backgroundColor: "#fff",
                  height: 55,
                  alignItems: "center",
                  boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                }}
              >
                <CardContent>
                  <Typography
                    component="div"
                    variant="body2"
                    style={{
                      // marginBottom: "30px",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      color: "#3D4F58",
                      fontSize: "11px",
                    }}
                  >
                    FAIR VALUE
                  </Typography>

                  <Typography variant="body2" color="text.secondary">
                    <CountUp
                      start={0}
                      prefix="GHS "
                      end={totalInvestmentFairValue}
                      duration={3}
                    />
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item>
              <Card
                elevation={0}
                sx={{
                  maxWidth: 345,
                  backgroundColor: "#fff",
                  height: 55,
                  alignItems: "center",
                  borderLeft: "5px solid #d33115",
                  boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                }}
              >
                <CardContent>
                  <Typography
                    component="div"
                    variant="body2"
                    style={{
                      // marginBottom: "30px",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      color: "#3D4F58",
                      fontSize: "11px",
                    }}
                  >
                    IMPAIRMENT
                  </Typography>

                  <Typography variant="body2" color="text.secondary">
                    <CountUp
                      start={0}
                      end={totalImpairment}
                      prefix="GHS "
                      duration={3}
                    />
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Paper
        elevation={0}
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          marginTop: "30px",
          backgroundColor: "transparent",
          boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        <LineChartHome />
        <DonutChart />
      </Paper>
      {monthStats.length > 0 && (
        <Paper
          elevation={0}
          onClick={handleClickOpen}
          style={{
            // backgroundColor: "#C9CED6",

            display: "flex",

            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            cursor: "pointer",
          }}
        >
          <Typography
            className="blinking-text"
            style={{
              fontSize: "16px",
              fontWeight: "bold",
              padding: "5px",
            }}
          >
            {monthStats.length} Investments will mature this month.
            <strong style={{ fontSize: "16px" }}>Click me for details</strong>
          </Typography>
        </Paper>
      )}
      <div style={{ width: "100%", height: "300px" }}>
        <StackedBarChartPerInstitution />
      </div>

      <div>
        <Dialog
          fullScreen
          open={open}
          onClose={handleClose}
          TransitionComponent={Transition}
        >
          <AppBar sx={{ position: "relative", backgroundColor: "#355c80" }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                Close
              </Typography>
            </Toolbar>
          </AppBar>
          <Paper style={{ width: "100%" }}>
            <DataGrid
              columns={columns}
              rows={rows2}
              // {...rows2}
              slots={{ toolbar: CustomToolbar }}
            />
          </Paper>
        </Dialog>
      </div>
    </div>
  );
}
